import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

/**
 * Feel free to modify this type for this project (only) here
 * For example, if you add a whole new block of text that the jslib does not have a spot for already
 *
 * This is not necessary if you are just overriding text for a pre-existing message id
 */
type ThisProjectMessages = {
    step: {
        personalInfo: {
            allFieldsRequired: string;
            graduationMonthPlaceholder: string;
            graduationYearPlaceholder: string;
        };
        pending: {
            redirectText: string;
        };
    };
};

/**
 * Define the actual language strings here, as needed.
 * This object should be sparse, so you inherit language from the library. Only override what you need to.
 *
 * The complicated type ensures your object adheres to the library's type(s), as well as any additional type you've
 * created in ThisProjectMessages.
 */
export const messagesSV: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    countryPlaceholder: 'Land',
    schoolNamePlaceholder: 'Universitet',
    firstNamePlaceholder: 'Förnamn',
    lastNamePlaceholder: 'Efternamn',
    emailAddressPlaceholder: 'E-postadress',
    birthDate: 'Födelsedatum',
    verifyMyStudentStatus: 'Bekräfta och fortsätt',
    infoShared1: 'Informationen i detta formulär kommer att användas i verifikationssyfte och delas med Lumion. ',
    infoShared2: ' ',
    getHelp: 'Vanliga frågor om SheerID',
    poweredBy: 'Verifieringstjänsterna driftas av SheerID.',
    step: {
        personalInfo: {
            title: 'Verifiera ditt studentbevis',
            graduationMonthPlaceholder: 'Examen månad',
            graduationYearPlaceholder: 'Examen år',
            subtitle: 'Bekräfta din behörighet genom att fylla i formuläret nedan.',
            allFieldsRequired: 'Alla fält måste fyllas i',
        },
        docUpload: {
            title: 'Ladda upp dokumentation',
        },
        pending: {
            titleReview: 'Sendningen lyckades!',
            titleCountdown: 'Sendningen lyckades!',
            redirectText: 'Slutför',
        },
        success: {
            title: 'Lyckades!',
            emailNotification: 'Tack för att du nu har verifierat ditt studentbevis!',
            redirectButtonText: 'Slutför',
        },
        error: {
            errorId: {
                verificationLimitExceeded: {
                    title: 'Tidsgränsen för verifikation har överskridits',
                },
            },
        },
    },
};
